import { render } from "./index.vue?vue&type=template&id=1c7b6e90"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/products/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c7b6e90"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c7b6e90', __exports__)) {
    console.log('reload')
    api.reload('1c7b6e90', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=1c7b6e90", () => {
    console.log('re-render')
    api.rerender('1c7b6e90', render)
  })

}


export default __exports__